export const practices = {
  family: [
    "child-support",
    "child-custody",
    "divorce",
    "alimony",
    "else",
    "reschedule",
  ] as const,
  immigration: [
    "green-card",
    "citizenship",
    "fiance-visa",
    "other-visa",
    "else",
    "reschedule",
  ] as const,
} as const;

export type Practices = typeof practices;

export type Practice = keyof Practices;

export type FamilySubPractice = Practices["family"][number];

export type ImmigrationSubPractice = Practices["immigration"][number];

export type SubPractice = FamilySubPractice | ImmigrationSubPractice;
